import { render } from "./PolicyView.vue?vue&type=template&id=bf6c9f8a&scoped=true"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import "./PolicyView.vue?vue&type=style&index=0&id=bf6c9f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6c9f8a"]])

export default __exports__